import { Form, Formik, FormikProps } from "formik";
import style from "./PasswordForm.module.scss";
import * as Yup from 'yup';
import { Input } from "@ui";
import { forwardRef } from "react";
import { IPassword } from "@interfaces/user/user";

const PasswordForm = forwardRef<FormikProps<IPassword>, {}>((_, ref) => {
    return (
        <div className={style.container}>
            <p className={style.formLabel}>Особисті дані</p>
            <Formik
                innerRef={ref}
                initialValues={{
                    oldPassword: "",
                    newPassword: "",
                    confirmPassword: ""
                }}
                validationSchema={Yup.object({
                    newPassword: Yup.string()
                    .min(8, "Пароль має містити не менше 8 символів")
                    .test(
                        "is-req",
                        "Новий пароль - обов'язкове поле",
                        (value, context) => {
                            if (context.parent.oldPassword) {
                                return Boolean(value)
                            } else {
                                return true;
                            }
                        },
                    ),
                    confirmPassword: Yup.string()
                    .min(8, "Пароль має містити не менше 8 символів")
                    .test(
                        "is-equal",
                        "Паролі не збігаються",
                        (value, context) => {
                            return context.parent.newPassword === value
                        },
                    ),
                })}
                onSubmit={(values, actions) => {}}
            >
                {props => (
                    <Form className="flex flex-col gap-[20px]">
                        <Input
                            label={"Старий пароль"}
                            type="password"
                            onChange={(newValue) => {
                                props.setFieldValue("oldPassword", newValue.trim())
                            }}
                            onBlur={props.handleBlur}
                            value={props.values.oldPassword}
                            name="oldPassword"
                            customStyle={{
                                width: "!max-w-full !w-full"
                            }}
                            error={props.errors.oldPassword}
                        />
                        <Input
                            label={"Новий пароль"}
                            type="password"
                            onChange={(newValue) => {
                                props.setFieldValue("newPassword", newValue.trim())
                            }}
                            onBlur={props.handleBlur}
                            value={props.values.newPassword}
                            name="newPassword"
                            customStyle={{
                                width: "!max-w-full !w-full"
                            }}
                            error={props.errors.newPassword}
                        />
                        <Input
                            label={"Підтвердити пароль"}
                            type="password"
                            onChange={(newValue) => {
                                props.setFieldValue("confirmPassword", newValue.trim())
                            }}
                            onBlur={props.handleBlur}
                            value={props.values.confirmPassword}
                            name="confirmPassword"
                            customStyle={{
                                width: "!max-w-full !w-full"
                            }}
                            error={props.errors.confirmPassword}
                        />
                    </Form>
                )}
            </Formik>
        </div>
    )
})

export { PasswordForm }